import './carousel-nav.scss';

const chevronDirection = {
  prev: 'left',
  next: 'right',
};

const CarouselNavButton = ({ direction, onClick, disabled, ariaLabel, variant = 'solid', placement = 'inset' }) => (
  <button
    type="button"
    className={`carousel-nav carousel-nav--${direction} carousel-nav--${variant} carousel-nav--${placement}`}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={onClick}
  >
    <i className={`fa-solid fa-chevron-${chevronDirection[direction]}`} aria-hidden="true"></i>
  </button>
);

const CarouselNav = ({
  onPrevious,
  onNext,
  canPrevious = true,
  canNext = true,
  previousLabel = 'Previous',
  nextLabel = 'Next',
  variant = 'solid',
  placement = 'inset',
}) => (
  <>
    <CarouselNavButton
      direction="prev"
      onClick={onPrevious}
      disabled={!canPrevious}
      ariaLabel={previousLabel}
      variant={variant}
      placement={placement}
    />
    <CarouselNavButton
      direction="next"
      onClick={onNext}
      disabled={!canNext}
      ariaLabel={nextLabel}
      variant={variant}
      placement={placement}
    />
  </>
);

export default CarouselNav;
export { CarouselNavButton };
